<template>
    <v-combobox
      v-model="value"
      :items="items"
      :loading="isLoading"
      :search-input.sync="searchString"
      hide-selected
      :clearable="true"
      label=""
      :placeholder="options[type]['label']"
      hint="Начните набирать и выберете из предложенных вариантов"
      no-filter
      :no-data-text="options[type]['noDataText']"
      @change="changed"
      @blur="$v.value.$touch()"
      :error-messages="errorMessages()"
      dense
    >
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.text"></v-list-item-title>
            <v-list-item-subtitle
              v-if="data.item.subdata"
              v-html="data.item.subdata"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-combobox>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import { required } from 'vuelidate/lib/validators'

// eslint-disable-next-line no-undef
const token = 'Token ' + dadataToken
const dadataAxios = axios.create({
  baseURL: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: token
  }
})
dadataAxios.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return Qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false
    })
  }
  return config
})

export default {
  name: 'DadataAutocomplete',

  data: () => ({
    value: '',
    items: [],
    isLoading: false,
    searchString: '',
    options: {
      address: {
        label: 'Адрес (город, улица...)',
        noDataText: 'Адреса не найдено',
        url: 'suggest/address'
      },
      party: {
        label: 'Компания (название)',
        noDataText: 'Компаний не найдено',
        url: 'suggest/party'
      },
      bank: {
        label: 'Банк (название, БИК, ИНН, адрес...)',
        noDataText: 'Банки не найдены',
        url: 'suggest/bank'
      },
      email: {
        label: 'Email',
        noDataText: 'Предложения не найдены',
        url: 'suggest/email'
      },
      fio: {
        label: 'ФИО',
        noDataText: 'Предложений нет',
        url: 'suggest/fio'
      }
    }
  }),
  validations: {
    value: {
      required: required
    }
  },
  props: {
    type: {
      type: String,
      default: 'address',
      validator: function (value) {
        return ['address', 'party', 'bank', 'email', 'fio'].indexOf(value) !== -1
      }
    }
  },
  methods: {
    async fetchSuggestions (queryString, count) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      try {
        const queryData = {
          query: typeof queryString === 'string' ? queryString : (typeof queryString === 'object' && queryString.value ? queryString.value : ''),
          count: count
        }
        const lb = Vue.ls.get('locations_boost')
        if (lb) {
          queryData.locations_boost = lb
        }
        const url = this.options[this.type].url
        const response = await dadataAxios.post(url, queryData)
        // const suggestions = response.data.suggestions.map(function (elem) { return elem.value })
        this.isLoading = false
        // return suggestions
        return response.data.suggestions
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async changed (value) {
      let data = await this.fetchSuggestions(value, 1)
      data = data && data.length > 0 ? data[0] : value
      this.$emit('hasChanged', data)
    },
    errorMessages () {
      const errorsList = []
      const validateData = this.$v.value
      if (!validateData.$dirty) {
        return []
      }
      if (!validateData.required) {
        errorsList.push(' ')
      }
      return errorsList
    }
  },
  watch: {
    searchString: async function (newV, oldV) {
      if (!newV && !oldV) {
        return
      }
      // обращаться к сервису dadata за подсказками не после каждого введенного символа а через одного
      if (!newV || (newV.length % 2) !== 0) {
        return
      }
      const newItems = await this.fetchSuggestions(newV, 5)
      if (!newItems || newItems.length === 0) {
        this.items = []
        return
      }
      try {
        const items = newItems.map(function (elem) {
          return {
            text: elem.value,
            value: elem.value,
            subdata: elem.data.address ? elem.data.address.unrestricted_value : null
          }
        })

        this.items = items
        // this.items = newItems.map(function (elem) { return elem.value })
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted () {
    if (!Vue.ls.get('locations_boost')) {
      dadataAxios.get('iplocate/address')
        .then(function (response) {
          const kladrId = response.data.location.data.kladr_id || false
          if (kladrId) {
            Vue.ls.set('locations_boost', [{ kladr_id: kladrId }], 3600 * 1000)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
    this.$v.value.$touch()
  }
}
</script>
